import { Tab } from '../vendor/bootstrap';
import { Swiper, Navigation, Keyboard, A11y, Thumbs } from '../vendor/swiper';

// Extend Modal to open specific tab based on data attribute
document.addEventListener('show.bs.modal', function (e) {
  const trigger = e.relatedTarget;
  if (!trigger) return;

  const tabName = trigger.getAttribute('data-tab');
  if (!tabName) return;

  const modal = e.target;
  const tabButton = modal.querySelector(`#${tabName}-tab`);

  if (tabButton) {
    const tab = new Tab(tabButton);
    tab.show();
  }
});

const blockId = '#property-media-modal';
const sliderMainContainer = document.querySelector(`${blockId} .mainPhotosSlider`);
const sliderThumbsContainer = document.querySelector(`${blockId} .thumbsPhotosSlider`);

if (sliderMainContainer && sliderThumbsContainer) {
  const swThumbsOptions = {
    spaceBetween: 8,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        spaceBetween: 16,
        slidesPerView: 4,
      },
      1200: {
        spaceBetween: 24,
        slidesPerView: 5,
      },
    }
  }
  let swiperThumbs = new Swiper(sliderThumbsContainer, swThumbsOptions);

  const swMainOptions = {
    modules: [Navigation, Keyboard, A11y, Thumbs],
    keyboard: { enabled: true },
    a11y: { enabled: true },
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      prevEl: `${blockId} .swiper-slider-nav .swiper-button-prev`,
      nextEl: `${blockId} .swiper-slider-nav .swiper-button-next`,
    },
    thumbs: {
      swiper: swiperThumbs,
    },
  }
  let swiperMain = new Swiper(sliderMainContainer, swMainOptions);
}